import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-details-order',
  templateUrl: './details-order.component.html',
  styleUrls: ['./details-order.component.scss']
})
export class DetailsOrderComponent implements OnInit {

  orderDetails;
    totalMrp=0;
    totalDiscount=0;
    sellingPrice=0;
    shippingFee=0;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router:Router,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    ) { }


  ngOnInit() {

    this.route.params
      .subscribe(
        (params: Params) => {
          let orderId = +params['orderId'];
          console.log( orderId);
          this.getOrderDetails(orderId)
        }
      );

  }


  getOrderDetails(id)
  {
      console.log("calling order details")
      this.apiService.get(this.apiConfig.getOrderDetails+id).subscribe(
        (res: any) => {
          console.log(res.data[0])
          this.orderDetails= res.data[0];
          this.calculateTotal( res.data[0].order_detail)
        },
        (err) => {
          console.log(err);
        }
      );
  }


  
  approveRejectOrders(status)
  {
    let postData= {
      program_id:1,
      order_status: status,
      order_id: this.orderDetails.id,
      order_comment:'not important',
      payment_type:1
    };

      this.apiService.post(this.apiConfig.orderApproveReject,postData).subscribe(
        (res: any) => {
          console.log(res.data)
          this.router.navigateByUrl('/hubAdmin/list-order');
          this.toast.Success("Order status Updated")
        },
        (err) => {
          console.log(err);
          this.toast.Error("Failed to Update")

        }
      );
  }


  calculateTotal(products)
  {
    for(let prod of products){
      console.log(prod);
      this.totalMrp += (prod.product_total_price *prod.qty) 
     
      this.totalDiscount += (prod.product_price_discount_applied *prod.qty) 

      this.sellingPrice += (prod.product_fianl_price_after_discount *prod.qty) 
      // this.shippingFee += (prod.product_fianl_price_after_discount *prod.qty) 
    //  this.sellingPrice += (prod.product_fianl_price_after_discount *prod.qty) 

    }

  }

}
